import { Contained, Text } from './AuthModalButton.styled';

export default function AuthModalButton({
    'aria-label': ariaLabel,
    children,
    'data-testid': dataTestId,
    disabled,
    screen,
    type = 'button',
    variant = 'black',
    onClick,
}: AuthModalButtonProps) {
    function handleClick() {
        if (onClick) {
            onClick?.(screen || 'login');
        }
    }

    const buttonProps = {
        'aria-label': ariaLabel,
        'data-testid': dataTestId,
        disabled,
        onClick: handleClick,
    };

    if (variant === 'text') {
        return (
            <Text {...buttonProps} type="button">
                {children}
            </Text>
        );
    }

    return (
        <Contained $alt={variant === 'white'} {...buttonProps} type={type}>
            {children}
        </Contained>
    );
}
